import { render, staticRenderFns } from "./changeProcess.vue?vue&type=template&id=45b2e7d1&lang=pug"
import script from "./changeProcess.vue?vue&type=script&lang=js"
export * from "./changeProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports